import { alpha, Theme } from '@mui/material';

interface DialogBlurOptions {
  smallBlur?: boolean;
}

// Shared elliptical blur effect for dialog modals
export const getDialogBlurStyles = (
  theme: Theme,
  options?: DialogBlurOptions,
) => {
  const { smallBlur = false } = options || {};
  return {
    '&::after': {
      content: '""',
      position: 'absolute',
      right: '-5vw',
      bottom: '-20vh',
      left: '-5vw',
      height: smallBlur ? theme.spacing(150) : theme.spacing(212),
      borderRadius: '50%',
      filter: `blur(${theme.spacing(40)})`,
      backgroundColor: alpha(theme.palette.secondary.main, 0.4),
      zIndex: -1,

      [theme.breakpoints.up('md')]: {
        backgroundColor: alpha(theme.palette.secondary.main, 0.6),
      },
    },
  };
};
